import { Component } from "react";

import Nepal from "./Nepal";
// import TopPartiesWinLead from "./TopPartiesWinLead";
import TopPartiesSeatChart from "./TopPartiesSeatChart";

import LangContext from "../../../../contexts/LangContext";
import { getGlobalSummary, getProportionalSeat } from "../../../../helper";
import { COMBINE_PR } from "../../../../config";

import "./index.css";
import AllPartiesDRPR from "./AllPartiesDRPR";

class MapChart extends Component {
  static contextType = LangContext;
  constructor(props) {
    super(props);
    this.state = {
      fetched: false,
    };

    this.showAllParty = true; // set false to show only 4 inc. others

    this.allParties = { lead: [], win: [] };
    this.seatChartData = [];
    this.allPartiesDRPR = { dr: [], pr: [] };
    this.chartData = [];
  }

  componentDidMount() {
    const myData = JSON.parse(JSON.stringify(this.props.data));

    this.prepareData(myData, this.props.tab);
  }

  componentWillReceiveProps(nextProps) {
    const myData = JSON.parse(JSON.stringify(nextProps.data));
    if (nextProps.fetched) {
      this.prepareData(myData, nextProps.tab);
    }
  }

  prepareData(data, tab) {
    this.lang = this.context.lang;

    // All parties with at least 1 seat
    this.chartData = getGlobalSummary(data, this.showAllParty);

    let parties = this.chartData.win.filter((w) => w.win > 0 && !w.party.match(/I+\d/));

    this.seatChartData = [];
    if (this.showAllParty) {
      let independent = { party: "I", win: this.chartData.win.filter((w) => w.win > 0 && w.party.match(/I+\d/)).reduce((a, b) => a + b.win, 0) };
      this.allParties.win = [...parties, independent];
      this.allPartiesDRPR.dr = JSON.parse(JSON.stringify([...parties, independent]));
      this.seatChartData = [...parties, independent];
    } else {
      this.allParties.win = [...parties];
      this.allPartiesDRPR.dr = JSON.parse(JSON.stringify([...parties]));
      this.seatChartData = [...parties];
    }

    if (COMBINE_PR && this.props.dataPR) {
      if (tab === "provincial") {
        let prData = JSON.parse(JSON.stringify(this.props.dataPR))[tab];
        if (prData) {
          let tempPRData = [];
          prData.forEach((x) => {
            let prDataFormatted = getProportionalSeat(x.data, x.province);
            prDataFormatted.nationalParties.forEach((np) => {
              let exist = tempPRData.find((p) => p.party === np.party);
              if (exist) {
                exist.seat += np.seat;
              } else {
                tempPRData.push(np);
              }
            });
          });

          this.allPartiesDRPR.pr = tempPRData;
          this.seatChartData = this.seatChartData.map((x) => {
            const prSeat = tempPRData.find((y) => y.party === x.party);
            if (prSeat) x.win += prSeat.seat;
            return x;
          });
        }
      } else {
        let prData = JSON.parse(JSON.stringify(this.props.dataPR))[tab];
        if (prData) {
          prData = prData.find((x) => x.province === 0).data;

          prData = getProportionalSeat(prData, 0);

          this.allPartiesDRPR.pr = prData.nationalParties;
          this.seatChartData = this.seatChartData.map((x) => {
            const prSeat = prData.nationalParties.find((y) => y.party === x.party);
            if (prSeat) x.win += prSeat.seat;
            return x;
          });
        }
      }
    }

    parties = this.chartData.lead.filter((w) => parties.find((p) => p.party === w.party) && !w.party.match(/I+\d/));
    if (this.showAllParty) {
      let independent = { party: "I", lead: this.chartData.lead.filter((w) => w.lead > 0 && w.party.match(/I+\d/)).reduce((a, b) => a + b.win, 0) };
      this.allParties.lead = [...parties, independent];
    } else {
      this.allParties.lead = [...parties];
    }

    this.setState({ flag: true });
  }

  

  render() {
    // console.log(this.props.tab)
    // console.log(this.props.fetched)
    // console.log(this.props.parties)
    // console.log(this.allPartiesDRPR, 'this all partiesdrpr')
    return (
      <section className="sh-global-chart-section sh-map-chart">
        <div className="container pb-3">
          <Nepal fetched={this.props.fetched} tab={this.props.tab} provinces={this.props.provinces} parties={this.props.parties} data={this.props.data} />

          {/* <TopPartiesWinLead fetched={this.props.fetched} parties={this.props.parties} provinces={this.props.provinces} allParties={this.allParties} chartData={this.chartData} globalData={this.props.data} /> */}
          <AllPartiesDRPR tab={this.props.tab} fetched={this.props.fetched} parties={this.props.parties} allParties={this.allPartiesDRPR} />
          {/* <TopPartiesSeatChart fetched={this.props.fetched} parties={this.props.parties} chartData={this.seatChartData} /> */}
        </div>
      </section>
    );
  }
}

export default MapChart;
